import Order from './Order.view';

export default Order;
